module.exports = __webpack_public_path__ + "CriticalCraftShoppe.jpg?dcf266aa8f744625f3a83127de0f93a3";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CriticalCraftShoppe.jpg
// module id = 458
// module chunks = 0